import React from 'react';
import { Wordmark } from '@99designs/branding';
import type { Role } from '@99designs/site-navigation/consts';

interface Props {
    userRole: Role;
}

export function LogoLink({ userRole }: Props) {
    const homeUrl = userRole === 'logged-out' ? '/' : '/work';

    return (
        <a href={homeUrl} title={__('99designs by Vista')}>
            <Wordmark />
        </a>
    );
}
